import * as types from '../constants/ActionTypes/EzloGroup';
import * as controllerTypes from '../constants/ActionTypes/Controller';

import produce from 'immer';
// todo: currently not used and could be removed (integrated to 'ezlo' reducer);
const INITIAL_STATE = {
    isConnecting: false, // is group connecting
    isConnected: false, // is group connected
    serial: '', // selected controller serial number
    name: '', // group name
    data: {}, // group data, contains controllers info
};

export default produce((draft, action) => {
    switch (action.type) {
        case types.CONNECT_EZLO_GROUP: {
            draft.isConnecting = true;
            draft.isConnected = false;
            break;
        }
        case types.CONNECT_EZLO_GROUP_SUCCESS: {
            draft.isConnecting = false;
            draft.isConnected = true;
            break;
        }
        case types.CONNECT_EZLO_GROUP_ERROR: {
            draft.isConnecting = false;
            draft.isConnected = false;
            break;
        }
        case types.UPDATE_EZLO_GROUP_DATA: {
            draft.data = action.data;
            break;
        }
        case controllerTypes.CONNECT_EZLO_CONTROLLER: {
            draft.data[action.serial].isConnecting = true;
            draft.data[action.serial].isConnected = false;
            break;
        }
        case controllerTypes.CONNECT_EZLO_CONTROLLER_SUCCESS: {
            draft.data[action.serial].isConnecting = false;
            draft.data[action.serial].isConnected = true;
            break;
        }
        case controllerTypes.CONNECT_EZLO_CONTROLLER_ERROR: {
            draft.data[action.serial].isConnecting = false;
            draft.data[action.serial].isConnected = false;
            break;
        }
        case controllerTypes.UPDATE_CONTROLLER_DATA: {
            draft.data[action.serial] = { ...draft.data[action.serial], ...action.data };
            break;
        }
        case controllerTypes.SELECT_EZLO_CONTROLLER: {
            draft.serial = action.serial;
            break;
        }
        case types.DISCONNECT_EZLO_GROUP: {
            draft = INITIAL_STATE;
            break;
        }
    }
}, INITIAL_STATE);
